import { render, staticRenderFns } from "./check_product.vue?vue&type=template&id=6badb70e&scoped=true"
import script from "./check_product.vue?vue&type=script&lang=js"
export * from "./check_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badb70e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6badb70e')) {
      api.createRecord('6badb70e', component.options)
    } else {
      api.reload('6badb70e', component.options)
    }
    module.hot.accept("./check_product.vue?vue&type=template&id=6badb70e&scoped=true", function () {
      api.rerender('6badb70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage_new/form/components/check_product.vue"
export default component.exports